import { createApp } from 'vue'
import App from './App.vue'
import './category-list.scss'

createApp(App).mount('#app')
